import { Component, Input, ViewEncapsulation } from '@angular/core';
import {
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AddOrderToRemoteCartResponse } from '../order-detail.service';

@Component({
  templateUrl: './add-to-remote-cart-res-dialog.component.html',
  styleUrls: ['./add-to-remote-cart-res-dialog.component.scss'],
  standalone: true,
  imports: [NgIf, MatToolbarModule, MatIconModule, MatButtonModule, MatDialogModule],
  encapsulation: ViewEncapsulation.None,
})
export class AddToRemoteCartResDialogComponent {
  @Input() result: AddOrderToRemoteCartResponse;

  constructor(public dialogRef: MatDialogRef<AddToRemoteCartResDialogComponent>) {}
}
